import React from 'react';
import { Redirect } from 'react-router-dom';
import { ModuleProps } from 'types';

const OrdersModule: React.FC<ModuleProps> = () => {
  // FIXME: Temporarily redirec to Dashboard Orders screen
  return <Redirect to="/dashboard/orders" />;
};

export default OrdersModule;
